"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class CustomerService {
    /**
     * @param externalSubscriptionId
     * @returns any Ok
     * @throws ApiError
     */
    static getMyPaymentMethods(externalSubscriptionId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v1/customers/payment_methods',
            query: {
                'externalSubscriptionId': externalSubscriptionId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    static setupPaymentMethod(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v1/customers/payment_methods',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.CustomerService = CustomerService;
